/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("GoogleLogin", function () {
    const self = this;
    this.trace = false;
    this.auth2 = null;

    this.initGoogle = function (opts) {
      gapi.load('auth2', function(){
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        self.auth2 = gapi.auth2.init({
          client_id: opts.clientID +'.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          // Request scopes in addition to 'profile' and 'email'
          //scope: 'profile'
        });
          app.vm.GoogleLogin.attachLoginButton($(opts.googleBtn).get(-1));
      });
    };

    this.attachLoginButton = function(element) {
      self.auth2.attachClickHandler(element, {},

      function(googleUser) {
         const profile = googleUser.getBasicProfile();
         const token = googleUser.getAuthResponse().id_token;

         app.vm.SocialLoginCommon.doRemoteLogin(token, profile.getId(), profile.getGivenName(), profile.getFamilyName(), profile.getEmail(), 'Google', profile.getImageUrl(), profile, profile.getImageUrl());

      }, function(error) {
        app.console.log(JSON.stringify(error, undefined, 2));
      } );
    };
}).createVM();
